import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { useI18n } from 'locales';

function Heading() {
  const t = useI18n();
  return (
    <Grid sx={{ width: '100%', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
      <Typography variant='h2' color='secondary' sx={{ p: 2, fontWeight: 'bold' }}>
        {t('GIVING')}
      </Typography>
      <Divider sx={{ width: '97%', height: '4px', backgroundColor: 'primary.main' }} />
    </Grid>
  );
}

export default Heading;
